import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import { AppDrawer } from "components";
import { getNSLang } from "utils/lang.utils";
import { LangConstant, SystemConstant } from "const";
import PropTypes from "prop-types";
import SelectingListContact from "../AddingChat/SelectingListContact";
import { GroupInfoActions } from "redux-store";
import { useConversationContext } from "../MessengerChat/ConversationContext";

const AddingGroupMembers = ({ open, onClose, groupId }) => {
  const dispatch = useDispatch();
  const { groupDetail } = useConversationContext();

  const groupMemberIds = useMemo(() => {
    const groupMembers = groupDetail?.groupMembers;
    if (false === Boolean(Array.isArray(groupMembers) && groupMembers.length > 0)) return [];
    else return groupMembers.map(item => item.id);
  }, [groupDetail]);

  const handleAddingMember = selectedContact => {
    const memberIds = selectedContact.map(item => item.identifyId);
    dispatch(
      GroupInfoActions.addMemberGroup({
        groupId: groupId,
        memberIds: memberIds,
        memberInviteType: SystemConstant.ROLE_OBJ.member,
      }),
    );
    onClose();
  };

  return (
    <AppDrawer
      open={open}
      onClose={onClose}
      anchor={"right"}
      hideBackdrop={true}
      title={getNSLang(LangConstant.NS_HOME_CONVERSATION, LangConstant.TXT_ADD_NEW_MEMBER)}
    >
      <SelectingListContact groupMemberIds={groupMemberIds} onComplete={handleAddingMember} />
    </AppDrawer>
  );
};

AddingGroupMembers.propTypes = {
  open: PropTypes.bool,
  data: PropTypes.object,

  onClose: PropTypes.func,
};

AddingGroupMembers.defaultProps = {
  open: false,
  data: {},

  onClose: () => {},
};

export default AddingGroupMembers;
